import { Box, useMediaQuery, useTheme } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { TabsContentProps } from "./TabsContent.types";
import {
  ButtonLink
  // Carousel
  //CarouselCard
} from "../../components";
import { Carousel } from "../../components/Carousel_v2/Carousel.component";
import { CarouselStyle } from "../../components/Carousel_v2/Carousel.styles";
import { CarouselCardRestyle } from "../../components/CarouselCardRestyle/CarouselCardRestyle.component";
import {
  // CAROUSEL_TYPE,
  STATUS_LO
} from "../../consts";
import { useLanguageStore } from "../../stores";
import { createEndDate, createStartDate } from "../../utils/general";

export function TabsContentRelated({
  contentRelated,
  currentLO
} :
  & Required<
    Pick<
    TabsContentProps,
    | "contentRelated"
    >
  > & Pick<
  TabsContentProps,
  | "currentLO"

  >
) {
  const navigate = useNavigate();
  const minActivities  = 4;
  const showCta = (contentRelated.length > minActivities);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const language = useLanguageStore(state => state.language)?.id;

  return (
    <>
      { showCta &&
        <Box
          sx={ {
            display:"flex",
            justifyContent: "flex-end",
            width: "100%"
          } }
        >
          <ButtonLink
            onClick={ () => navigate(`/esplora/related/${currentLO?.id}`, { state:{
              title: currentLO?.title,
              typeLearning: currentLO?.learningObjectType,
              typologyLearning: currentLO?.learningObjectTypology
            }
            }) }
            sx={ {
              cursor: "pointer",
              fontSize: "1.125rem",
              fontWeight: "500",
              minWidth: "unset",
              padding: "1rem 0",
              textDecoration: "underline",
              whiteSpace: "nowrap",
              zIndex: "1000",

              "&:hover": {
                background:"none",
                boxShadow:"none"
              },
              [theme.breakpoints.down("sm")]: {
                fontSize:"0.75rem",
                paddingRight: "20px"
              },

              "&.Mui-disabled": {
                color:theme.customColors.backgroundDisabled,
                textDecoration:"none"
              }
            } }
          >
            { t("view_all") }
          </ButtonLink>

        </Box> }
      <CarouselStyle  className="carouselContainer"  sx={ { paddingBottom: "1rem" } }>
        <Carousel
          centeredSlides={ isMobile ?true :false }
          carouselData={ contentRelated }
          slidesPerView={  isMobile ? 1 : "auto" }
          spaceBetween={ isMobile ? 1 : 11.2 }
          loopSlides={ true }
          hasPagination={ false }
          hideSweeperBulletsRight={ true }
          hasPaginationSweeperBullets={ false }
          title={ "Related Carousel" } // :TODO da sistemare
          pauseOnMouseEnter={ true }
          renderElement={ (element,index ) => {
            return (
              <CarouselCardRestyle
                key={ `tabs-content-related-${index}--${language}` }
                loTag={ element.lo_Tag }
                isLinkRelative={ element.isLinkRelative }
                link={ element.link }
                canAccessNow={ element.canAccessNow }
                enrollType={ element.enrollType }
                booked={ element.status !== STATUS_LO.N && element.status !== STATUS_LO.T }
                categories={ element.topicTags || [] }
                coverPublicURL={ element.coverPublicURL }
                coverVideoPublicURL={ element.videoPublicURL }
                disabled={ false }
                duration={ element.duration }
                ecm_specialization={ element.ecm_specialization }
                ecmRegistration={ element.ecmRegistration }
                ecmType={ element.ecmType }
                editionNumber={ element.editionNumber }
                endDate={ createEndDate(element) }
                expirationDate={ element.expirationDate }
                id={ element.id }
                isAutoSubscribeEnable={ element.isAutoSubscribeEnable }
                isFavourite={ element.isFavourite }
                isEditorial={ element.isEditorial }
                isMandatory={ element.isMandatory }
                isSurvey={ element.isSurvey }
                isTest={ element.isTest }
                isToj={ element.isToj }
                learningObjectType={ element.learningObjectType }
                learningObjectTypology={ element.learningObjectTypology }
                percentageOfCompletion={ element.percentageOfCompletion }
                shortDescription={ element.shortDescription }
                startDate={ createStartDate(element) }
                status={ element.status || "N" }
                title={ element.title }
                small={ true }
                attributes={ element.attributes }
                externalFileUrl={ element?.externalFileUrl }
              />
            );
          } }/>
      </CarouselStyle>
    </>
  );
}
/*.  Unica prop settata a differenza della card in esplora
             <CarouselCard
              ** small={ true }
            />
 */
